import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { Loader, NumericInput, RadioButton } from "@livechat/design-system";
import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { Icon } from "components/icon";
import { ResponsiveBreakpoint, ResponsiveBreakpointType } from "constants/responsive-breakpoint";
import { StyledHr } from "routes/styled";
import { withVar } from "themes/helpers";

export const StyledLoader = styled(Loader)`
  justify-content: center;
  align-self: center;
  padding: ${withVar(SpacingToken.Spacing6)} 0;
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 11;
  padding-right: 33px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };

  @media (max-width: ${ResponsiveBreakpoint.Tablet}px) {
    padding: 0 34px;
  }
`;

export const StyledPricingSummary = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;

  > div:first-of-type {
    flex: 10;
  }
`;

export const StyledPricingRow = styled.div<{ verticallyCentered?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) =>
      props.verticallyCentered &&
      css`
        align-items: center;
      `
  };

  > div:first-of-type {
    flex: 10;
  }
`;

export const StyledRow = styled(StyledPricingRow)`
  padding: 8px 4px;
`;

export const StyledBillingCycleRow = styled(StyledRow)`
  @media (max-width: 1220px) {
    flex-direction: column;
    align-items: flex-start;

    p {
      margin-bottom: 0.5em;
    }

    .lc-radio {
      margin-bottom: 0.25em;
    }
  }

  @media (max-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Tablet]}px) {
    .lc-field-group {
      flex-direction: column;
    }
  }
`;

export const StyledCouponRow = styled(StyledRow)`
  @media (max-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Tablet]}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const StyledRadioButton = styled(RadioButton)`
  .lc-radio__text {
    flex: none;
  }
`;

export const BarWrapper = styled.div`
  margin: 0px 5px 16px;
`;

export const Hr = styled(StyledHr)`
  margin: 12px 5px;
`;

interface IStyledRowColumn {
  alignTop?: boolean;
}

export const StyledRowColumn = styled.div<IStyledRowColumn>`
  display: flex;
  flex-direction: column;
  justify-content: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.alignTop ? "flex-start" : "center")
  };
  gap: ${withVar(SpacingToken.Spacing4)};
`;

export const StyledRowName = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 1.5;
`;

interface IStyledPriceSummaryCell {
  color?: "green";
}

export const StyledPriceSummaryCell = styled.div<IStyledPriceSummaryCell>`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 1.5;

  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.color === "green" && `color: ${withVar(DesignToken.ActionPositiveDefault)}`
  }
`;

interface IStyledPriceSummaryCell {
  color?: "green";
}

export const StyledMainPriceSummaryCell = styled.div<IStyledPriceSummaryCell>`
  display: inline-flex;
  align-items: center;
  margin-top: -3px;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.33;

  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.color === "green" && `color: ${withVar(DesignToken.ActionPositiveDefault)}`
  }
`;

export const StyledRowDescription = styled.div`
  font-size: 14px;
  line-height: 1.3;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor60
  };
  margin-top: 5px;
`;

export const StyledNumericInput = styled(NumericInput)`
  width: 70px;
  input {
    font-size: 24px;
    text-align: center;
    color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.linkColor
    };
    font-weight: 600;
  }
`;

export const DiscountedPrice = styled.span`
  margin-right: 8px;
  font-size: 16px;
  font-weight: normal;
  text-decoration: line-through;
`;

export const StyledButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${withVar(SpacingToken.Spacing4)};
  justify-content: flex-end;
`;

export const StyledTooltipIconTrigger = styled(Icon)`
  margin-left: 8px;
`;
